import React from "react";
import "@/index.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./contexts/AuthContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import AuthPage from "./pages/AuthPage";
import AuthCallback from "./pages/AuthCallback";
import BrowsePage from "./pages/BrowsePage";
import ListingDetailPage from "./pages/ListingDetailPage";
import PostListingPage from "./pages/PostListingPage";
import MessagesPage from "./pages/MessagesPage";
import ProfilePage from "./pages/ProfilePage";
import PromoteListingPage from "./pages/PromoteListingPage";
import MapPage from "./pages/MapPage";
import PaymentSuccessPage from "./pages/PaymentSuccessPage";
import MyDashboardPage from "./pages/MyDashboardPage";
import AdminLayout from "./pages/admin/AdminLayout";
import AdminOverview from "./pages/admin/AdminOverview";
import AdminUsers from "./pages/admin/AdminUsers";
import AdminListings from "./pages/admin/AdminListings";
import AdminReports from "./pages/admin/AdminReports";
import AdminTransactions from "./pages/admin/AdminTransactions";
import AdminSettings from "./pages/admin/AdminSettings";
import AdminPromotionTiers from "./pages/admin/AdminPromotionTiers";
import AdminPromotions from "./pages/admin/AdminPromotions";
import AdminVerifications from "./pages/admin/AdminVerifications";
import AdminBusinessAccounts from "./pages/admin/AdminBusinessAccounts";
import AdminBusinessAds from "./pages/admin/AdminBusinessAds";
import AdminAnalytics from "./pages/admin/AdminAnalytics";

function AppRouter() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith('/admin');

  // Handle OAuth callback - check for session_id in hash
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }

  return (
    <>
      {!isAdmin && <Header />}
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/auth" element={<AuthPage />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/browse" element={<BrowsePage />} />
        <Route path="/map" element={<MapPage />} />
        <Route path="/listing/:id" element={<ListingDetailPage />} />
        <Route path="/post" element={<PostListingPage />} />
        <Route path="/messages" element={<MessagesPage />} />
        <Route path="/profile/:userId" element={<ProfilePage />} />
        <Route path="/promote/:listingId" element={<PromoteListingPage />} />
        <Route path="/payment-success" element={<PaymentSuccessPage />} />
        <Route path="/dashboard" element={<MyDashboardPage />} />
        {/* Admin Routes */}
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<AdminOverview />} />
          <Route path="analytics" element={<AdminAnalytics />} />
          <Route path="users" element={<AdminUsers />} />
          <Route path="listings" element={<AdminListings />} />
          <Route path="reports" element={<AdminReports />} />
          <Route path="promotion-tiers" element={<AdminPromotionTiers />} />
          <Route path="promotions" element={<AdminPromotions />} />
          <Route path="business-accounts" element={<AdminBusinessAccounts />} />
          <Route path="business-ads" element={<AdminBusinessAds />} />
          <Route path="verifications" element={<AdminVerifications />} />
          <Route path="transactions" element={<AdminTransactions />} />
          <Route path="settings" element={<AdminSettings />} />
        </Route>
      </Routes>
      {!isAdmin && <Footer />}
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
